const data: any = [{"key":"heading-order-card","copy":"You Must Order a <br> Personalized Card <br> to Continue"},{"key":"continue","copy":"Continue"},{"key":"order-personalized-card","copy":"Order Personalized Card"}];
export default data